// 考勤管理
export default [
  {
    path: '/attendance/clock-qurey',
    component: resolve => require(['@/pages/attendance/clock-query.vue'], resolve),
    name:'clock-qurey',
    meta: {
      title: '定位晚点'
    }
  },
  {
    path: '/attendance/clock-configure',
    component: resolve => require(['@/pages/attendance/clock-configure.vue'], resolve),
    name:'clock-configure',
    meta: {
      title: '定位晚点配置'
    }
  },
  {
    path: '/attendance/returnSchoolClock',
    component: resolve => require(['@/pages/attendance/returnSchoolClock.vue'], resolve),
    name:'returnSchoolClock',
    meta: {
      title: '返校打卡'
    }
  },
  {
    path: '/attendance/daily-statistics',
    component: resolve => require(['@/pages/attendance/daily-statistics.vue'], resolve),
    name:'daily-statistics',
    meta: {
      title: '每日统计'
    }
  },
  {
    path: '/attendance/month-statistics',
    component: resolve => require(['@/pages/attendance/month-statistics.vue'], resolve),
    name:'month-statistics',
    meta: {
      title: '月度汇总'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/attendance.js